import { useState, useEffect } from "react";
import "./status-component.css";

const StatusComponent = ({ type, title }) => {
  const [classType, setClassType] = useState("default");

  useEffect(() => {
    if (type === "success") {
      setClassType("success");
    } else if (type === "error") {
      setClassType("error");
    } else if (type === "warning") {
      setClassType("warning");
    } else {
      setClassType("default");
    }
  }, [type]);
  return <span className={`status-component ${classType}`}>{title}</span>;
};

export default StatusComponent;
